import React, { useState, useEffect } from 'react';
import { 
  Dialog, 
  DialogContent, 
  IconButton, 
  Box, 
  Typography, 
  useMediaQuery, 
  useTheme,
  Fade
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

// Styled Components for Premium Look
const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // Darker backdrop
    backdropFilter: 'blur(8px)', // Glassmorphism effect on backdrop
  },
  '& .MuiDialog-paper': {
    backgroundColor: 'rgba(20, 20, 30, 0.85)', // Dark semi-transparent background
    backdropFilter: 'blur(16px)', // Glassmorphism effect on modal
    borderRadius: '24px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
    overflow: 'hidden',
    maxWidth: '1200px',
    width: '95%',
    height: '90vh',
    margin: '16px',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '100%',
        margin: 0,
        borderRadius: 0,
    }
  },
}));

const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 24px',
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  background: 'linear-gradient(90deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 100%)',
}));

const Title = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  fontSize: '1.25rem',
  letterSpacing: '0.5px',
  background: 'linear-gradient(45deg, #007FFF, #0059B2)',
  WebkitBackgroundClip: 'text',
  // WebkitTextFillColor: 'transparent',
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.7)',
  transition: 'all 0.3s ease',
  '&:hover': {
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    transform: 'rotate(90deg)',
  },
}));

const IframeContainer = styled(Box)({
  width: '100%',
  height: 'calc(100% - 70px)', // Subtract header height
  position: 'relative',
  overflow: 'hidden',
});

const StyledIframe = styled('iframe')({
  width: '100%',
  height: '100%',
  border: 'none',
  display: 'block',
});

const StrategyDemoModal = ({ open, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="xl"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
    >
      <Header>
        <Title variant="h6">
          AI 交易助理 Demo
        </Title>
        <StyledIconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </StyledIconButton>
      </Header>
      
      <IframeContainer>
        <StyledIframe 
          src="https://trade.masquant.com/strategydemo" 
          title="Strategy Demo"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          loading="lazy"
        />
      </IframeContainer>
    </StyledDialog>
  );
};

export default StrategyDemoModal;
